import { j as o } from "../../../../../node_modules/react/jsx-runtime.js";
import r from "../../../../atoms/Icon/Icon.js";
const c = ({ direction: t, id: e }) => /* @__PURE__ */ o.jsx("div", { className: "flex items-center justify-center p-025 w-fit h-fit", children: /* @__PURE__ */ o.jsx(
  r,
  {
    name: { asc: "arrow-up", desc: "arrow-down" }[t ?? "asc"],
    className: `${t ? "text-color-fg-bold" : "text-color-fg-lightest"} cursor-pointer hover:text-color-fg-bold active:text-color-fg-bold`,
    "data-testid": `table-sort-icon-${e}`
  }
) });
export {
  c as default
};
//# sourceMappingURL=TableSort.js.map
